import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';
import classNames from 'classnames';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

const styles = theme => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  completeContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  fadeInAnimation: {
    opacity: 1,
    transition: 'opacity 1s ease-in-out',
  },
  fullOpacity: {
    opacity: 1,
  },

  loadingContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  topHalf: {
    minHeight: 150,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomHalf: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'auto',
  },

  supportNumber: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    //background: 'green',
  },

  actionContainer: {
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 5,
    paddingBottom: 5,
  },
  image: {
    maxHeight: '100%',
    maxWidth: '80%',
    // boxShadow: '0px 0px 5px #4495DC',
    borderRadius: '5px',
  },

  questionLabel: {
    fontSize: '1.5rem',
    textAlign: 'center',
    //fontWeight: 'bold',
    marginBottom: 10,
  },

  questionLabel2: {
    fontSize: '1rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 10,
  },
});

const TitleCard = withStyles(styles)(
  ({
    cardNumber,
    questionImage,
    questionLabel,
    questionLabel2,
    navLabel,
    confirmAnswer,
    classes,
    hideActions,
    selfInspectIntro,
    submitInspection,
    isSaving,
    pendingSaves,
    failedSaves,
    goBack,
    hideBackButton,
  }) => {
    const savesInProgress = pendingSaves.filter(ps => !ps.complete).length + failedSaves.length;
    const hasFailedSaves = !!failedSaves.length;

    const handleContinue = () => {
      if (navLabel === 'Finish Survey!') {
        submitInspection(cardNumber);
      } else {
        confirmAnswer({
          cardNumber,
        });
      }
    };

    return (
      <div className={classes.container}>
        <div
          className={classnames(classes.container, !hasFailedSaves && !savesInProgress && classes.fadeInAnimation)}
          style={{
            opacity: hasFailedSaves || !!savesInProgress ? 0 : 1,
          }}
        >
          <div className={classes.topHalf}>
            <img className={classes.image} src={questionImage} />
          </div>

          <div className={classes.bottomHalf}>
            {!!questionLabel && (
              <SelfInspectQuestionLabel isHeader dangerouslySetInnerHTML>
                {questionLabel}
              </SelfInspectQuestionLabel>
            )}

            {!hideActions && !!questionLabel2 && (
              <>
                <SelfInspectQuestionLabel style={{ textAlign: 'center', marginTop: 10 }}>
                  {questionLabel2}
                </SelfInspectQuestionLabel>
              </>
            )}

            {cardNumber === 1 && questionLabel2 !== 'error' && (
              <>
                <div className="flex-1" />

                <div className={classes.supportNumber} style={{ marginTop: 10 }}>
                  <div className={classes.questionLabel2}>
                    If you have any questions, please don't hesitate to call us at:{' '}
                    <div styles="white-space: nowrap;">
                      <a href="tel:+14406288304">(440) 628-8304</a>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {!hideActions && !hasFailedSaves && !savesInProgress && (
            <div className={classes.actionContainer}>
              {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="flex-1 mr-20" />}

              <SelfInspectButton
                //
                label={navLabel}
                onClick={handleContinue}
                className="flex-1"
              />
            </div>
          )}
        </div>

        {(!!savesInProgress || hasFailedSaves) && (
          <div className={classNames(classes.loadingContainer, 'flex-1')}>
            <div
              style={{
                position: 'relative',
                width: 100,
                height: 100,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress
                style={{
                  color: '#2F89D9',
                  position: 'absolute',
                  width: 100,
                  height: 100,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                }}
              />

              <span
                style={{
                  fontSize: '2rem',
                  color: '#0003',
                }}
              >
                {savesInProgress}
              </span>
            </div>

            <div style={{ marginTop: 24, textAlign: 'center' }}>Please wait while we finish some things up.</div>
            <div style={{ marginTop: 24, textAlign: 'center' }}>
              Photos left to upload: <span style={{ fontWeight: 'bold' }}>{savesInProgress}</span>
            </div>

            {hasFailedSaves && (
              <>
                <div style={{ marginTop: 24, textAlign: 'center', fontWeight: 'bold' }} className="text-note">
                  Please ensure you have a good internet connection while your images are uploaded.
                </div>
              </>
            )}
          </div>
        )}
      </div>
    );
  },
);

TitleCard.propTypes = {};

TitleCard.defaultProps = {};

export default TitleCard;
